import { TextField } from '@mui/material'
import { GRID_FORM_CONFIG_T } from '../../../common/FormGenerator' 
import { TextFieldCode, TextFieldEmail } from './style'

export type AuthFormBlockName = 'email' | 'code'

export const emailConfig: GRID_FORM_CONFIG_T<{ email: string }> = [
    [
        {
            id: 1,
            controllerName: 'email',
            RenderElement: TextField,
            renderProps: () => ({
                placeholder: 'Email',
                size: 'small',
                sx: TextFieldEmail,
                fullWidth: true,
            }),
        },
    ],
]

export const codeConfig: GRID_FORM_CONFIG_T<{ code: string }> = [
    [
        {
            id: 2,
            controllerName: 'code',
            RenderElement: TextField,
            renderProps: () => ({
                placeholder: 'Код из письма',
                size: 'small',
                sx: TextFieldCode,
                fullWidth: true,
            }),
        },
    ],
]

const formConfigs: Record<AuthFormBlockName, GRID_FORM_CONFIG_T<unknown>> = {
  email: emailConfig as GRID_FORM_CONFIG_T<unknown>,
  code: codeConfig as GRID_FORM_CONFIG_T<unknown>,
}

export const getFormConfig = (blockName: AuthFormBlockName) => formConfigs[blockName]
